/*
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack
 * @Email : kpozos@ibl.mx
 *
 */
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {SUB_VIEW_MODEL} from "../../../DiningOrders/Model/Models";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import { USER_TYPE_MODEL } from "../../../../../enums/userTypeEnum";

const RequestMealSubHeader = ({
                                  subView,
                                  handleShowActive,
                                  handleShowHistory,
                                  searchId,
                                  setBodyForExport,
                                  results,
                                  setResults,
                                  searchElement,
                                  setSearchElement,
                                  option,
                                  rowsPerPage,
                                  setSearch,
                                  simpleSearch,
                                  setSimpleSearch,
                                  getData,
                                  userTypeId,
                                  activeStep
}) => {

    return (
        <>
            <div className='d-flex gap-2 mb-3'>
                {userTypeId === USER_TYPE_MODEL.EMPLOYEE && (
                    <>
                        <ButtonAction
                            id='btn_rms_active'
                            name='active'
                            className={
                                subView === SUB_VIEW_MODEL.REQUEST_MEALS.ACTIVE
                                    ? 'btn-outlined-secondary-600-100'
                                    : 'btn-outlined-secondary-600-00'
                            }
                            disabled={false}
                            splitName={false}
                            onClick={handleShowActive}
                        />

                        <ButtonAction
                            id='btn_rms_history'
                            name='history'
                            className={
                                subView === SUB_VIEW_MODEL.REQUEST_MEALS.HISTORY
                                    ? 'btn-outlined-secondary-600-100'
                                    : 'btn-outlined-secondary-600-00'
                            }
                            disabled={false}
                            splitName={false}
                            onClick={handleShowHistory}
                        />
                    </>
                )}
                {(subView === SUB_VIEW_MODEL.REQUEST_MEALS.HISTORY  || activeStep === 1)  && (
                    <div className='flex-grow-1'>
                        <SearchSimple
                            id={searchId}
                            setBodyForExport={setBodyForExport}
                            setSearchResults={setResults}
                            searchResults={results}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            optionTable={option}
                            rowsPerPage={rowsPerPage}
                            setSearch={setSearch}
                            simpleSearch={simpleSearch}
                            setSimpleSearch={setSimpleSearch}
                            contractorId={null}
                            supplierId={null}
                            callApi={() => getData(0, { searchElement})}
                            resetApi={() => getData(0, {searchElement: ''})}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default RequestMealSubHeader;
